// extracted by mini-css-extract-plugin
module.exports = {"image":"_3uC9Me _1fZRjn _1yjWDR _2DVeGU"};